import {React, useState, useEffect, useRef, useContext} from 'react'
import {Select,MenuItem, Button, ListItemText, Checkbox, TextField, ListSubheader, Skeleton} from '@mui/material'
import { useNotify, useTranslate } from 'react-admin'
import {notificationServices} from 'src/services/sales/notification/notification.service.ts'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import LoadingButton from '@mui/lab/LoadingButton'
import DownloadIcon from '@mui/icons-material/Download';
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs'
import { NotificationContext } from './NotificationContext';
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission';

const ASSIGNED_TYPE = 0;
const WATCHED_TYPE = 1;
const CREATED_TYPE = 2;

export const NotificationFilters = ({setPaginationItemData, setLoadingItems, setNotifications, paginationItemData, setTotalCount, notificationsOrder}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const location = useLocation();
    const {reasonsOptions, resolutionsOptions, resolutionsLoading} = useContext(NotificationContext)
    const [statuses, setStatuses] = useState([])
    const [projects, setProjects] = useState([])
    const [notificationsType, setNotificationsType] = useState(0)
    const [userLoading, setUserLoading] = useState(false)
    const [preFilter, setPreFilter] = useState({
        status:[],
        project:'',
        subject:'',
        created_from:null,
        created_until:null,
        description:'',
        group:'',
        issueID:'',
        asignated_to:'',
        watcher:'',
        created:'',
        reason:'',
        resolution:''
    })
    const [users, setUsers] = useState([])
    const [assignatedId, setAssignatedId] = useState('')
    const [usersFiltered, setUsersFiltered] = useState([])
    const [userFilter, setUserFilter] = useState('')
    const hasMounted = useRef(false);
    const [groups, setGroups] = useState([])
    const [groupFiltered, setGroupFiltered] = useState([])
    const [projectFilter, setProjectFilter] = useState('')
    const [projectFiltered, setProjectFiltered] = useState([])
    const typeOptions = [
        {id:0, label:translate('ra.message.assigned')},{id:1, label:translate('ra.message.watched')},{id:2, label:translate('ra.message.created')}
    ]
    const [loadingExport, setLoadingExport] = useState(false)

    const getStatuses = () =>{
        notificationServices.getStatuses().then(res=>{
            setStatuses(res.issue_statuses)
        }).catch(err=>console.log("error", err))
    }

    const getProjects = () =>{
        notificationServices.getProjects().then(res=>{
            setProjects(res.projects)
            setProjectFiltered(res.projects)
        })
    }

    const getUsers = async () =>{
        setUserLoading(true)
        await notificationServices.getUsersAndGroups().then((res)=>{
            setUserLoading(false)
            setUsers(res.data?.users)
            setGroups(res.data?.groups)
            setGroupFiltered(res.data?.groups)
            setUsersFiltered(res.data?.users)
        }).catch((res)=>{
            console.log("error", res)
        })
    }

    const onExport = async () =>{
        setLoadingExport(true)
        await notificationServices.export(preFilter, notificationsType, hasPermissionFunction('notification','special')).finally(()=>{
          setLoadingExport(false)
        }).catch(()=>{
          notify('ra.message.export_error')
        }).then(res=>{
          const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'export.csv';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        })
      }

    useEffect(()=>{
        if(userFilter){
            setUserLoading(true)
            const handler = setTimeout(() => {
                setUsersFiltered(users?.filter(user=>
                    user.name?.toLowerCase().includes(userFilter?.toLowerCase())
                ))
                setGroupFiltered(
                    groups?.filter(group=>
                        group.name?.toLowerCase().includes(userFilter?.toLowerCase())
                    )
                )
            }, 500);
            setUserLoading(false)
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setUsersFiltered(users)
            setGroupFiltered(groups)
        }
        
    },[userFilter])

    useEffect(()=>{
        if(projectFilter){
            setUserLoading(true)
            const handler = setTimeout(() => {
                setProjectFiltered(projects?.filter(project=>
                    project.name?.toLowerCase().includes(projectFilter.toLowerCase())
                ))
            }, 500);
            setUserLoading(false)
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setProjectFiltered(projects)
        }
        
    },[projectFilter])

    useEffect(() => {
        if (hasMounted.current) {
        onFilter();
        } else {
        hasMounted.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationItemData,notificationsOrder]);

    useEffect(()=>{
        getStatuses()
        getProjects()
        getUsers()
        const id = location.pathname.split("/")[2]
        if(id){
            preFilter.issueID = id
            onFilter()
        }
    },[])

    useEffect(()=>{
        if(assignatedId){
            const userFilter = {
                asignated_to:notificationsType === 0 ?assignatedId:null,
                watcher:notificationsType === 1 ?assignatedId:null,
                created:notificationsType === 2 ?assignatedId:null
            }
            if(preFilter && userFilter){
                setPreFilter({...preFilter, ...userFilter})
            }
        }
        
    },[assignatedId, notificationsType])

    const handleChange = (value, field) =>{
        setPreFilter({
            ...(preFilter ?? {}),
            [field]: value?.target.value
        })

        if (field === 'project') {
            setProjectFilter('')
        }
    }

    const onFilter = () =>{
        setLoadingItems(true)
        preFilter.offset = paginationItemData.page
        preFilter.limit = paginationItemData.rowsPerPage
        preFilter.order = notificationsOrder.order
        preFilter.sort = notificationsOrder.sort
        if(notificationsType === ASSIGNED_TYPE){
            notificationServices.getAssignedNotification(preFilter).then(res=>{
                let postFilter = res.issues ? res.issues : res.issue ? [res.issue] :[]
                setNotifications(postFilter)
                setTotalCount(res.total_count)
            }).finally(()=>setLoadingItems(false))
            .catch((err)=>{
                notify('ra.message.notification_filter_error', {type:'error'})
            })
        } else if(notificationsType === WATCHED_TYPE){
            notificationServices.getWatchedNotification(preFilter).then(res=>{
                let postFilter = res.issues ? res.issues : res.issue ? [res.issue] :[]
                setNotifications(postFilter)
                setTotalCount(res.total_count)
            }).finally(()=>setLoadingItems(false))
            .catch(()=>{
                notify('ra.message.notification_filter_error', {type:'error'})
            })
        } else if(notificationsType === CREATED_TYPE){
            notificationServices.getCreatedNotification(preFilter).then(res=>{
                let postFilter = res.issues ? res.issues : res.issue ? [res.issue] :[]
                setNotifications(postFilter)
                setTotalCount(res.total_count)
            }).finally(()=>setLoadingItems(false))
            .catch(()=>{
                notify('ra.message.notification_filter_error', {type:'error'})
            })
        }
    }

    const onClear = () =>{
        setPreFilter({project:'', status:[], created_from:null, created_until:null, subject:'', group:'', description:'', issueID:''})
        setNotificationsType(0)
        setPaginationItemData({page:0, rowsPerPage:10})
        setAssignatedId('')
        setUserFilter('')
    }

    return (
        <div >
            <LoadingButton
                style={{display:'flex',justifySelf:'flex-end'}}
                onClick={onExport}
                loading={loadingExport}
            >
                <DownloadIcon/>
                {translate('ra.action.export')}
            </LoadingButton>
            <div style={{display:'flex', flexDirection:'row', width:'100%', flexWrap:'nowrap',justifyContent:'space-evenly'}}>
                <Select
                    fullWidth
                    size='small'
                    style={{marginRight:'10px'}}
                    onChange={(value)=>{setNotificationsType(value.target.value)}}
                    defaultValue={0}
                    value={notificationsType}
                    displayEmpty
                    renderValue={(selected) => {
                        return selected !== '' ?
                            typeOptions.find(option=>option.id === notificationsType)?.label
                            : translate('ra.field.task_role')
                    }}
                >
                    {
                        typeOptions?.map(type=>(
                            <MenuItem key={type.id} value={type.id}>
                                {type.label}
                            </MenuItem>
                        ))
                    }
                </Select>
                <Select
                    style={{marginRight:'10px'}}
                    fullWidth
                    id='type'
                    size='small'
                    value={preFilter.project}
                    renderValue={(selected) => (
                        selected ? (
                            projects.find(project => project.id === selected)?.name
                        ) : translate('ra.field.message_type')
                    )}
                    onChange={(value)=>handleChange(value, 'project')}
                    defaultValue={''}
                    displayEmpty
                >
                    <ListSubheader>
                        <TextField
                            size="small"
                            autoFocus
                            placeholder={translate('ra.action.search')}
                            fullWidth
                            value={projectFilter}
                            onChange={(e) => {e.stopPropagation();setProjectFilter(e.target.value)}}
                            onClick={(e) => e.stopPropagation()} // prevent closing on click
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                    </ListSubheader>
                    {userLoading ?
                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                    :
                        projectFiltered?.length === 0 ?
                            <MenuItem disabled>
                                {translate('ra.message.noResultsAvailable')}
                            </MenuItem>
                    :
                        projectFiltered?.map(project=>(
                            <MenuItem key={project.id} value={project.id}>
                                {project.name}
                            </MenuItem>
                        )
                    )}
                </Select>
                <Select
                    style={{marginRight:'10px'}}
                    fullWidth
                    id='users'
                    size='small'
                    value={assignatedId}
                    renderValue={(selected) => {
                        if(selected){
                            const userFound = usersFiltered.find(user => user.id === selected)
                            const groupFound = groupFiltered.find(group => group.id === selected)
                            return (
                                userFound? userFound.name : groupFound ? groupFound.name : ''
                            )
                        }
                    return translate('ra.field.user')
                    }}
                    onChange={(value)=>{
                        setAssignatedId(value.target.value)
                    }}
                    defaultValue={''}
                    displayEmpty
                >
                    <ListSubheader>
                        <TextField
                            size="small"
                            autoFocus
                            placeholder={translate('ra.action.search')}
                            fullWidth
                            value={userFilter}
                            onChange={(e) => {
                                e.stopPropagation();
                                setUserFilter(e.target.value)
                            }}
                            onClick={(e) => e.stopPropagation()} // prevent closing on click
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                    </ListSubheader>
                    {userLoading ?
                            <Skeleton variant='rectangular' width={'100%'} height={40} />
                        :
                        usersFiltered?.length === 0 && groupFiltered?.length === 0?
                        <MenuItem disabled>
                            {translate('ra.message.noResultsAvailable')}
                        </MenuItem>
                        :[
                        usersFiltered?.length > 0 &&
                        <MenuItem disabled>
                            {translate('ra.field.user')}
                        </MenuItem>,
                        usersFiltered &&
                        ([...usersFiltered?.map(user=>(
                            <MenuItem key={user.id} value={user.id}>
                                {user.name}
                            </MenuItem>
                        ))]),
                        groupFiltered?.length > 0 &&
                        <MenuItem disabled>
                            {translate('ra.field.group')}
                        </MenuItem>,
                        groupFiltered &&
                        ([...groupFiltered?.map(user=>(
                            <MenuItem key={user.id} value={user.id}>
                                {user.name}
                            </MenuItem>
                        ))])
                        ]
                }
                </Select>
                <Button style={{marginRight:'10px'}} variant='outlined' onClick={onFilter}>
                    {translate('ra.action.filter')}
                </Button>
                <Button variant='outlined' onClick={onClear}>
                    {translate('ra.action.clear')}
                </Button>
            </div>
            <div style={{display:'flex', flexDirection:'row', marginTop:'15px', justifyContent:'space-evenly'}}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label={translate('ra.field.created_from')}
                        value={preFilter.created_from}
                        inputFormat="DD/MM/YYYY"
                        maxDate={preFilter.created_until}
                        renderInput={(params)=>(
                            params &&
                            <TextField
                                {...params}
                                size='small'
                                style={{marginRight:'10px',width:'500px'}}
                            />
                        )}
                        onChange={(value)=>{
                            if (value && dayjs(value).isValid()) {
                                const isoDate = dayjs(value).toISOString().split('T')[0];
                                if(preFilter){
                                    setPreFilter({ ...preFilter, created_from: isoDate });
                                }
                            } else {
                                if(preFilter){
                                    setPreFilter({ ...preFilter, created_from: null });
                                }
                            }
                        }}
                    />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label={translate('ra.field.created_until')}
                        value={preFilter.created_until}
                        inputFormat="DD/MM/YYYY"
                        minDate={preFilter.created_from}
                        renderInput={(params)=>(
                            params &&
                            <TextField
                                {...params}
                                size='small'
                                style={{marginRight:'10px',width:'500px'}}
                            />
                        )}
                        onChange={(value)=>{
                        if (value && dayjs(value).isValid()) {
                                const isoDate = dayjs(value).toISOString().split('T')[0];
                                if(preFilter){
                                    setPreFilter({ ...preFilter, created_until: isoDate });
                                }
                            } else {
                                if(preFilter){
                                    setPreFilter({ ...preFilter, created_until: null });
                                }
                            }
                        }}
                    />
                </LocalizationProvider>
                <Select
                    style={{marginRight:'10px'/* , width:'17%' */}}
                    fullWidth
                    size='small'
                    onChange={(value)=>handleChange(value, 'status')}
                    defaultValue={[]}
                    value={preFilter.status}
                    displayEmpty
                    multiple
                    renderValue={(values) => {
                        return (values?.length > 0 ? statuses?.filter(status=>values.includes(status.id))
                            .map(status=>
                                status.name
                            )
                            .join(', ')
                            :
                            translate('ra.field.status'))
                    }}
                >
                    {
                        statuses?.map(status=>(
                            <MenuItem key={status.id} value={status.id}>
                                <Checkbox checked={preFilter.status?.includes(status?.id )} />
                                <ListItemText primary={status.name}/>
                            </MenuItem>
                        ))
                    }
                </Select>
            </div>
            <div style={{display:'flex', flexDirection:'row', marginTop:'15px', justifyContent:'space-evenly'}}>
                <TextField
                    placeholder={'Id'}
                    fullWidth
                    type='number'
                    onChange={(value)=>handleChange(value, 'issueID')}
                    size='small'
                    value={preFilter.issueID}
                    style={{marginRight:'10px'}}
                />
                <TextField
                    placeholder={translate('ra.field.subject')}
                    fullWidth
                    onChange={(value)=>handleChange(value, 'subject')}
                    size='small'
                    value={preFilter.subject}
                    style={{marginRight:'10px'}}
                />
                <TextField
                    placeholder={translate('ra.field.description')}
                    fullWidth
                    onChange={(value)=>handleChange(value, 'description')}
                    size='small'
                    value={preFilter.description}
                    /* style={{marginRight:'10px'}} */
                />
            </div>
            <div style={{display:'flex', flexDirection:'row', marginTop:'15px', justifyContent:'space-evenly'}}>
                <HasPermission permission='special' resource={'notification'}>
                    <Select
                        fullWidth
                        id='reason'
                        size='small'
                        onChange={(value)=>handleChange(value, 'reason')}
                        defaultValue={''}
                        value={preFilter.reason}
                        displayEmpty
                        style={{marginRight:'10px'}}
                        renderValue={(values) => {
                            return (preFilter.reason ? preFilter.reason
                                :
                                translate('ra.field.support_reason'))
                        }}
                    >
                        {
                            resolutionsLoading ?
                            <Skeleton variant='rectangular' width={'100%'} height={40} />  :
                            reasonsOptions?.map((reason, index)=>(
                                <MenuItem key={index} value={reason.value}>
                                    {reason.label}
                                </MenuItem>
                            ))
                        }
                    </Select>
                    <Select
                        fullWidth
                        id='resolution'
                        size='small'
                        displayEmpty
                        onChange={(value)=>handleChange(value, 'resolution')}
                        defaultValue={''}
                        value={preFilter.resolution}
                        renderValue={(values) => {
                            return (preFilter.resolution ? preFilter.resolution
                                :
                                translate('ra.field.resolution'))
                        }}
                    >
                        {
                            resolutionsLoading ?
                                <Skeleton variant='rectangular' width={'100%'} height={40} />  :
                            resolutionsOptions?.map((resolution, index)=>(
                                <MenuItem key={index} value={resolution.value}>
                                    {resolution.label}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </HasPermission>
            </div>
        </div>
    )
}
